export const ERROR_TYPES = {
  BILL_PAID_COMTREX_ERROR: 'BILL_PAID_COMTREX_ERROR',
  OUTSTANDING_AMOUNT_NOW_ZERO: 'OUTSTANDING_AMOUNT_NOW_ZERO',
  AMOUNT_DUE_DECREASED: 'AMOUNT_DUE_DECREASED',
  MORE_ORDERED: 'MORE_ORDERED',
  DUPLICATE_GIFT_CARD: 'DUPLICATE_GIFT_CARD',
  INSUFFICIENT_GIFT_CARD_FUNDS: 'INSUFFICIENT_GIFT_CARD_FUNDS',
  GIFT_CARD_NOT_FOUND: 'GIFT_CARD_NOT_FOUND',
  GIFT_CARD_SERVICE_DOWN: 'GIFT_CARD_SERVICE_DOWN',
  MAXIMUM_GIFT_CARD_ATTEMPTS: 'MAXIMUM_GIFT_CARD_ATTEMPTS',
  MAXIMUM_CARD_NUMBER_LENGTH: 'MAXIMUM_CARD_NUMBER_LENGTH',
  INVALID_VOUCHER_TYPE: 'INVALID_VOUCHER_TYPE',
  PAYMENT_PROCESSING_TIMEOUT: 'PAYMENT_PROCESSING_TIMEOUT',
};

export default {
  // bill errors
  [ERROR_TYPES.BILL_PAID_COMTREX_ERROR]: {
    error: ERROR_TYPES.BILL_PAID_COMTREX_ERROR,
    text: 'billPaidError',
  },
  [ERROR_TYPES.OUTSTANDING_AMOUNT_NOW_ZERO]: {
    error: ERROR_TYPES.OUTSTANDING_AMOUNT_NOW_ZERO,
    text: 'outstandingAmountNowZero',
  },
  [ERROR_TYPES.AMOUNT_DUE_DECREASED]: {
    error: ERROR_TYPES.AMOUNT_DUE_DECREASED,
    text: 'amountDueDecreased',
  },
  [ERROR_TYPES.MORE_ORDERED]: {
    error: ERROR_TYPES.MORE_ORDERED,
    text: 'moreOrdered',
  },
  // gift card errors
  [ERROR_TYPES.DUPLICATE_GIFT_CARD]: {
    error: ERROR_TYPES.DUPLICATE_GIFT_CARD,
    text: 'duplicate',
  },
  [ERROR_TYPES.INSUFFICIENT_GIFT_CARD_FUNDS]: {
    error: ERROR_TYPES.INSUFFICIENT_GIFT_CARD_FUNDS,
    text: 'insufficientFunds',
  },
  [ERROR_TYPES.GIFT_CARD_NOT_FOUND]: {
    error: ERROR_TYPES.GIFT_CARD_NOT_FOUND,
    text: 'cardNotFound',
  },
  [ERROR_TYPES.GIFT_CARD_SERVICE_DOWN]: {
    error: ERROR_TYPES.GIFT_CARD_SERVICE_DOWN,
    text: 'serviceDown',
  },
  [ERROR_TYPES.MAXIMUM_GIFT_CARD_ATTEMPTS]: {
    error: ERROR_TYPES.MAXIMUM_GIFT_CARD_ATTEMPTS,
    text: 'maximumGiftCardAttempts',
  },
  [ERROR_TYPES.MAXIMUM_CARD_NUMBER_LENGTH]: {
    error: ERROR_TYPES.MAXIMUM_CARD_NUMBER_LENGTH,
    text: 'cardNumber',
  },
  [ERROR_TYPES.INVALID_VOUCHER_TYPE]: {
    error: ERROR_TYPES.INVALID_VOUCHER_TYPE,
    text: 'invalidVoucherType',
  },

  // payment
  [ERROR_TYPES.PAYMENT_PROCESSING_TIMEOUT]: {
    error: ERROR_TYPES.PAYMENT_PROCESSING_TIMEOUT,
    text: 'paymentTimeout',
  },
};
